import { IRequest } from './../../models/request';
import { IGeneralData, SortByOptions } from './../../models/general.model';
import { IUser } from './../../models/user.model';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export interface GeneralState extends EntityState<IGeneralData> {}

export const generalAdapter: EntityAdapter<IGeneralData> = createEntityAdapter<IGeneralData>({
  selectId: model => model.id,
});

export interface HotelHeaderInfo {
  title: string;
  stars: number;
  location: string;
  cost: number;
}
const request: IRequest = {
  location: '', latitude: -1, longitude: -1, fromdate: '',
  todate: '', maxprice: -1, minprice: -1, rooms: 0,
  roompersons: [], roomLift: false, disableAccess: false, smoking: false,
  roomLiftOpt: false, disableAccessOpt: false, smokingOpt: '', starRating: -1,
  accomType: -1, mealType: -1, personalReq: '', requestExpiry: -1,
  hotelfacilities: '', hotelroomfacilities: '', opthotelfacilities: '',
  opthotelroomfacilities: '', hotelextras: [], userid: -1
};

const hotelInfo: HotelHeaderInfo = {
  title: '', stars: 0,  location: '',  cost: 0
};

const defaultState = {
  ids: [1],
  entities: {
      1: {
        footerType: '',
        headerType: '',
        id: 1,
        isLoading: false,
        sortByOption: SortByOptions.SORT_BY_PRICE_ASC,
        lastRequestAsked: request,
        hotelHeaderInfo: hotelInfo,
        isBookingActionEnabled: false,
        user: null,
        unreadMessages: 0,
        activeOffers: 0,
        loginModalOpened: false,
        bookNowBtnClicked: false,
        isRequestSendEnabled: false
      }
  }
};

export const initialState: GeneralState = generalAdapter.getInitialState(defaultState);



